"use client";

import { api } from "@/api";
import { confirmModal } from "@/component/ConfirmModal";
import { configStore } from "@/store/configStore";
import { userStore } from "@/store/user";
import { observer } from "mobx-react-lite";
import Link from "next/link";
import React from "react";
import Button from "../../../component/Button";
import ArrowLinkIcon from "../assets/arrow-link.svg";
import { FAQItem } from "./FAQItem";

export const FAQSection: React.FC = observer(() => {
  const faqs = configStore.pricingPageConfig?.faqs;
  const faqLink = configStore.pricingPageConfig?.faqLink;

  const handleDeleteAccount = async () => {
    if (!userStore.isLogin) {
      window.location.href = "/login";
      return;
    }

    try {
      await confirmModal.confirm({
        title: "Delete My Account",
        content:
          "This will permanently delete your account and remove your personal data from VidMuse. This action cannot be undone. If you have active subscription plan, please remember to cancel first.",
        continueText: "Delete my account",
        backText: "Back",
        width: 400,
        backButtonWidth: 120,
        confirmCountdown: 5,
      });

      await api.user.deactivateUser();
      window.location.href = "/";
    } catch (error) {
      // User cancelled or API failed
      console.error("Failed to deactivate user:", error);
    }
  };

  if (!faqs || faqs.length === 0) {
    return null;
  }

  return (
    <div className="mt-[90px]">
      <h2
        id="faq"
        className="text-center text-2xl font-bold text-text-primary leading-normal"
      >
        Frequently Asked Questions
      </h2>

      <div className="mt-10 px-5 xl:px-0 max-w-5xl mx-auto">
        {faqs.map((item, index) => (
          <FAQItem
            key={`faq-${index}`}
            question={item.question}
            answer={item.answer}
          />
        ))}
        <FAQItem
          key={`faq-delete-account`}
          question="How to delete my account?"
          answer={
            <div className="text-sm font-normal text-text-secondary">
              You can click{" "}
              <Button
                type="plain"
                onClick={handleDeleteAccount}
                className="mx-0.5 text-text-primary font-medium transition-colors cursor-pointer"
              >
                Delete My Account
              </Button>{" "}
              to delete your account. Please note that once your account is
              deleted, it cannot be undone. Please be certain.
            </div>
          }
        />
      </div>

      {faqLink && (
        <div className="mt-8 text-center flex items-center justify-center">
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={faqLink}
            className="text-white!"
          >
            <span className="font-medium mr-2">Help Center</span>
            <ArrowLinkIcon className="inline-block w-[10px] h-[10px]" />
          </Link>
        </div>
      )}
    </div>
  );
});
